import { ISettingsType } from "../types";

export function formatNumberWithSymbol(value: number, settings: ISettingsType | null) {
    const {
        swipe_symbol: swipeSymbol = false,
        symbol = '',
        decimal = 2
    } = settings || {};

    let formattedNumber = value && !isNaN(value)
        ? parseFloat(String(value)).toFixed(decimal)
        : '0.' + '0'.repeat(decimal);

    formattedNumber = formattedNumber.replace('.', ',');

    return swipeSymbol === false
        ? `${symbol}${formattedNumber}`
        : `${formattedNumber}${symbol}`;
}